import { Injectable } from '@angular/core';

import { Subject } from 'rxjs';
import { shareReplay } from 'rxjs/operators';

import { ToastData } from './toast.model';

@Injectable()
export class StaticToastService {
  private notificationSubj = new Subject<ToastData>();
  notification$ = this.notificationSubj.pipe(shareReplay(1));

  clearNotification() {
    this.notificationSubj.next(null);
  }

  postNotification(data: ToastData) {
    this.notificationSubj.next(data);
  }
}
